import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteSummaryReportRTF } from './Pages';

export const RouteSummaryReportRTFRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={RouteSummaryReportRTF} />
    </Fragment>
)